// Details Collapsible Panels
function togglePanel(panel) {
  // const thisToggle = panel;
  panel.classList.toggle('is-open');
  event.target.classList.toggle('is-open');
}
const toggleBtns = document.querySelectorAll('button[data-toggle]');
if (toggleBtns) {
  toggleBtns.forEach(btn => btn.addEventListener('click', ()=> {
    const thisPanel = event.target.getAttribute('data-toggle');
    const thisTarget = document.querySelector(thisPanel);
    togglePanel(thisTarget);
  }));
}

const footerMenuBtns = document.querySelectorAll('.footer__menu h3');
if(footerMenuBtns) {
  footerMenuBtns.forEach(btn => btn.addEventListener('click', ()=> {
    const thisPanel = event.target.nextElementSibling;
    const thisMenu = thisPanel.querySelector('.menu');
    togglePanel(thisMenu);
  }));
}



// WEBPACK FOOTER //
// ./scripts/util/togglePanel.js